// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"218":"ed6c2b47","451":"8aaf82ce","561":"cf269e03","936":"c124c017","945":"13ea4f1f"}[chunkId] + ".js";
};